export default (
  state = {
    assetFoldersTree: null,
    assetFolderContent: null,
    assetFolderContentIds: [],
    assetBreadcrumbData: [],
    currentFolderID: null,
    assetColumnConfigs: [],
    assetStatusList: [],
    assetTagsList: [],
    currentSelectedFolder: null,
    assetItemCollaboratorList: [],
    assetSearchSuggestions: null,
    // assetSearchContent: {},
    // assetSearchContentIds: [],
    searchTerm: "",
    currentView: "all",
    assetStatusFilters: [],
  },
  action,
) => {
  switch (action.type) {
    case "ASSET_INIT_DATA":
      return {
        ...state,
        assetFolderContent: action.payload.assetFolderContent,
        assetFolderContentIds: action.payload.assetFolderContentIds,
        assetBreadcrumbData: action.payload.assetBreadcrumbData,
        // assetStatusList: action.payload.assetStatusList,
        // assetTagsList: action.payload.assetTagsList,
        currentFolderID: action.payload.currentFolderID,
        currentSelectedFolder: action.payload.currentSelectedFolder,
      };
    case "GET_ASSET_FOLDER_TREE":
      return {
        ...state,
        assetFoldersTree: action.payload,
      };
    case "ASSET_STATUS_LIST": {
      const { assetFolderContent, statusList, isUpdate } = action.payload;
      if (isUpdate) {
        return { ...state, assetStatusList: statusList, assetFolderContent };
      }
      return { ...state, assetStatusList: statusList };
    }
    case "GET_ASSET_TAG_LIST": {
      return {
        ...state,
        assetTagsList: action.payload,
      };
    }

    case "ASSET_STATUS_DELETE":
      return {
        ...state,
        assetStatusList: state.assetStatusList.filter(
          item => item.id !== action.payload.deletedStatusId,
        ),
      };
    case "ASSET_TAGS_LIST": {
      const { assetFolderContent, tagsList, isUpdate } = action.payload;
      if (isUpdate) {
        return { ...state, assetTagsList: tagsList, assetFolderContent };
      }
      return { ...state, assetTagsList: tagsList };
    }
    // case "ASSET_TAGS_LIST":
    //   return {
    //     ...state,
    //     assetTagsList: action.payload,
    //   };
    case "ASSET_TAG_DELETE":
      return {
        ...state,
        assetTagsList: state.assetTagsList.filter(
          item => item.id !== action.payload.deletedTagId,
        ),
      };
    case "ASSET_FOLDER_CONTENTS":
      return {
        ...state,
        assetFolderContent: action.payload.assetFolderContent,
        assetFolderContentIds: action.payload.assetFolderContentIds,
        assetBreadcrumbData: action.payload.assetBreadcrumbData,
        currentFolderID: action.payload.currentFolderID,
        currentSelectedFolder: action.payload.currentSelectedFolder,
      };
    case "ASSET_CREATE_NEW_FOLDER":
      return { ...state, assetFoldersTree: action.payload };
    case "ASSET_DELETE_ITEMS":
      return {
        ...state,
        assetFolderContent: {
          ...state.assetFolderContent,
          page: {
            ...state.assetFolderContent.page,
            inodes: action.payload.folderContent,
          },
        },
        assetFoldersTree: action.payload.foldersTree,
        assetFolderContentIds: action.payload.assetFolderContentIds,
        assetBreadcrumbData: action.payload.assetBreadcrumbData,
      };

    case "ASSET_MOVE_TO_FOLDER_ITEMS":
      return {
        ...state,
        assetFolderContent: {
          ...state.assetFolderContent,
          page: {
            ...state.assetFolderContent.page,
            inodes: action.payload.folderContent,
          },
        },
        assetFoldersTree: action.payload.foldersTree,
        assetFolderContentIds: action.payload.assetFolderContentIds,
        assetBreadcrumbData: action.payload.assetBreadcrumbData,
      };
    case "ASSET_RENAME_ITEM":
      return {
        ...state,
        assetFolderContent: {
          ...state.assetFolderContent,
          page: {
            ...state.assetFolderContent.page,
            inodes: action.payload.folderContent,
          },
        },
        assetFoldersTree: action.payload.foldersTree,
        assetBreadcrumbData: action.payload.assetBreadcrumbData,
      };
    case "ASSET_UPDATE_COLUMN_CONFIGS":
      return { ...state, assetColumnConfigs: action.payload };
    case "ASSET_ITEM_COLLABORATORS_LIST":
      return { ...state, assetItemCollaboratorList: action.payload };
    case "ASSET_ITEM_COLLABORATORS_ACCESS":
      return { ...state, assetItemCollaboratorList: action.payload };
    case "UPDATE_ASSET_STATUS":
      return {
        ...state,
        assetFolderContent: {
          ...state.assetFolderContent,
          page: {
            ...state.assetFolderContent.page,
            inodes: state.assetFolderContent.page.inodes.map(inode => {
              if (action.payload.docId === inode.file_id) {
                return {
                  ...inode,
                  document_status: action.payload.newStatus,
                };
              }
              return inode;
            }),
          },
        },
      };
    case "UPDATE_ASSET_TAG":
      return {
        ...state,
        assetFolderContent: {
          ...state.assetFolderContent,
          page: {
            ...state.assetFolderContent.page,
            inodes: state.assetFolderContent.page.inodes.map(inode => {
              if (action.payload.docId === inode.file_id) {
                return { ...inode, document_tag: action.payload.newTag };
              }
              return inode;
            }),
          },
        },
      };

    case "UPDATE_ASSET_SEARCH_SUGGESTIONS":
      return {
        ...state,
        assetSearchSuggestions: action.payload.assetSearchSuggestions,
      };

    case "UPDATE_ASSET_SEARCH_CONTENT":
      return {
        ...state,
        assetFolderContent: action.payload.assetSearchContent,
        assetFolderContentIds: action.payload.assetSearchContentIds,
        searchTerm: action.payload.searchTerm,
      };

    case "ASSET_CLEAR_SEARCH_TERM_ACTION":
      return {
        ...state,
        searchTerm: "",
      };

    case "UPDATE_DOCUMENT_LIST":
      return {
        ...state,
        assetFolderContent: action.payload.assetFolderContentData,
        assetFolderContentIds: action.payload.assetFolderContentIdsData,
      };
    case "TOGGLE_ASSET_DOCUMENT_LIST_VIEW":
      return {
        ...state,
        currentView: action.payload,
        assetFolderContent: {
          ...state.assetFolderContent,
          page: {
            ...state.assetFolderContent.page,
            page_num: 1,
          },
        },
      };
    case "UPDATE_ASSET_SWIMLANE":
      return {
        ...state,
        assetFolderContent: {
          ...state.assetFolderContent,
          page: {
            ...state.assetFolderContent.page,
            inodes: state.assetFolderContent.page.inodes.map(inode => {
              if (action.payload.docId === inode.file_id) {
                return {
                  ...inode,
                  lane: action.payload.laneData,
                };
              }
              return inode;
            }),
          },
        },
      };
    case "UPDATE_BLOCKCHAIN_ORDER":
      return {
        ...state,
        assetFolderContent: {
          ...state.assetFolderContent,
          page: {
            ...state.assetFolderContent.page,
            inodes: state.assetFolderContent.page.inodes.map(inode => {
              if (action.payload.docId === inode.file_id) {
                return {
                  ...inode,
                  blockchain_order: action.payload.blockchainOrderData,
                };
              }
              return inode;
            }),
          },
        },
      };
    case "UPDATE_STATUS_FILTERS":
      return {
        ...state,
        assetStatusFilters: action.payload,
      };
    default:
      return state;
  }
};
